import React, { useMemo } from 'react';
import Checkbox from '../../../Components/Base/Checkbox/Checkbox';
import { useMetaQuery } from '../../../graphql/graphql';
import useMeta from '../../Meta/Hooks/useMeta';
import { useAppContext } from '../../../Services/AppContext';

const META_KEY = 'patientProfileChangeNotification';

function parseBool(v: unknown): boolean {
	if (typeof v === 'boolean') {
		return v;
	}

	if (v === 'true' || v === true) {
		return true;
	}

	return false;
}

const PatientProfileNotificationPreference: React.FC = () => {
	const { userData } = useAppContext();
	const { createUserMeta } = useMeta();
	const { data, isLoading, refetch } = useMetaQuery(
		{ userId: userData.id, key: META_KEY },
		{ skip: !userData?.id },
	);

	const checked = useMemo(
		() => parseBool(data?.meta?.value),
		[data?.meta?.value],
	);

	const handleChange = async (value: boolean) => {
		const result: any = await createUserMeta(userData.id, META_KEY, value);
		if (result?.status === 200) {
			await refetch();
		}
	};

	return (
		<Checkbox
			tx='component.notificationsSetup.patientProfileChangeDoctor'
			onChange={handleChange}
			value={checked}
			disabled={isLoading}
		/>
	);
};

export default PatientProfileNotificationPreference;
